var __jsx = React.createElement;
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { PageLayout } from "../../../util/constants";
var ContactUs = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.ContactUs;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var ContactUsPage = function ContactUsPage() {
  var _store$common;
  var store = useStore();
  var brandCodeDesc = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCodeDesc;
  var _useState = useState(""),
    title = _useState[0],
    setTitle = _useState[1];
  useEffect(function () {
    var getPageTitle = function getPageTitle() {
      return brandCodeDesc ? "Contact Us | ".concat(brandCodeDesc) : "Contact Us";
    };
    setTitle(getPageTitle());
  }, [brandCodeDesc]);
  useEffect(function () {
    var _store$user;
    store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || (_store$user = _store$user.analyticsModel) === null || _store$user === void 0 || _store$user.dispatchPageViewEvent();
  }, []);
  useEffect(function () {
    store === null || store === void 0 || store.initComponent("ContactUs").then(function () {
      // NOOP
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, title)), __jsx(ContactUs, null));
};
ContactUsPage.layout = PageLayout.DP_LAYOUT;
ContactUsPage.layoutProps = {};
export default observer(ContactUsPage);